import { z } from 'zod';

import { ShigoRole } from '../../../../auth/permissions';

export const adminUserFormSchema = z
  .object({
    email: z.string().trim().min(1, 'users.validation.emailRequired'),
    name: z.string().trim().min(1, 'users.validation.nameRequired'),
    password: z.string(),
    roles: z.array(z.string()),
    publisherIds: z.array(z.string()),
    agencyIds: z.array(z.string()),
    networkId: z.string(),
    memberships: z.array(
      z.object({
        networkId: z.string().min(1),
        roles: z.array(z.string()),
        publisherIds: z.array(z.string()),
        agencyIds: z.array(z.string()),
      }),
    ),
    creating: z.boolean(),
    superAdmin: z.boolean(),
  })
  .superRefine((value, context) => {
    if (value.creating && !z.email().safeParse(value.email).success) {
      context.addIssue({
        code: 'custom',
        path: ['email'],
        message: 'users.validation.email',
      });
    }
    if (value.creating && !value.password) {
      context.addIssue({
        code: 'custom',
        path: ['password'],
        message: 'users.validation.passwordRequired',
      });
    }
    if (!value.superAdmin && value.roles.length === 0) {
      context.addIssue({
        code: 'custom',
        path: ['roles'],
        message: 'users.validation.rolesRequired',
      });
    }
    if (
      !value.superAdmin &&
      value.roles.includes(ShigoRole.Publisher) &&
      value.publisherIds.length === 0
    ) {
      context.addIssue({
        code: 'custom',
        path: ['publisherIds'],
        message: 'users.validation.publisherRequired',
      });
    }
    if (
      !value.superAdmin &&
      value.roles.includes(ShigoRole.Agency) &&
      value.agencyIds.length === 0
    ) {
      context.addIssue({
        code: 'custom',
        path: ['agencyIds'],
        message: 'users.validation.agencyRequired',
      });
    }
    if (value.superAdmin && value.memberships.length === 0) {
      context.addIssue({
        code: 'custom',
        path: ['memberships'],
        message: 'users.validation.networkRequired',
      });
    }
    if (value.superAdmin) {
      value.memberships.forEach((membership, index) => {
        if (membership.roles.includes(ShigoRole.Agency) && membership.agencyIds.length === 0) {
          context.addIssue({
            code: 'custom',
            path: ['memberships', index, 'agencyIds'],
            message: 'users.validation.agencyRequired',
          });
        }
        if (membership.roles.length === 0) {
          context.addIssue({
            code: 'custom',
            path: ['memberships', index, 'roles'],
            message: 'users.validation.rolesRequired',
          });
        }
        if (
          membership.roles.includes(ShigoRole.Publisher) &&
          membership.publisherIds.length === 0
        ) {
          context.addIssue({
            code: 'custom',
            path: ['memberships', index, 'publisherIds'],
            message: 'users.validation.publisherRequired',
          });
        }
      });
    }
  });

export type AdminUserFormValue = z.infer<typeof adminUserFormSchema>;
